
import './FormFilterWrapper.scss';

const FormFilterWrapper = ({children}) =>
{

    return (
        <div className='user-filter-div-outer'>
            {children.map((filter) =>
            {
                return (<div className='user-filter-div-inner'>
                    {filter}
                </div>)
            })}
        </div>
    )

}

export default FormFilterWrapper;